// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"08e1e2c8","513":"87d19a0f","703":"041860bd","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};